import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgHealthSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.582 11.25-1.517-3.033a1.75 1.75 0 0 0-3.13 0L7.418 11.25H3.612a5.06 5.06 0 0 1 .132-4.06 5.13 5.13 0 0 1 1.283-1.676 5.212 5.212 0 0 1 1.852-1.026 5.26 5.26 0 0 1 4.134.434c.361.203.696.448.998.73A5.243 5.243 0 0 1 17.13 4.51a5.21 5.21 0 0 1 1.845 1.025 5.129 5.129 0 0 1 1.279 1.671 5.065 5.065 0 0 1 .142 4.044h-6.814ZM8.709 14.738a1.744 1.744 0 0 1-.209.012H6.573l4.91 4.787a.75.75 0 0 0 1.048 0l4.911-4.787H12.5a1.75 1.75 0 0 1-1.565-.967l-.435-.87-.435.87a1.75 1.75 0 0 1-1.356.955Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.25a.75.75 0 0 1 .67.415l1.793 3.585H21a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.67-.415l-1.33-2.658-1.33 2.658a.75.75 0 0 1-.67.415H3a.75.75 0 0 1 0-1.5h5.036L9.83 8.665a.75.75 0 0 1 .671-.415Z",
  fill: "currentColor"
})));

export { SvgHealthSolid as default };
